import React, { Component } from "react";
import { fire, auth } from "../../../firebase/index";
//? English Version
import loginInstruction1 from "../../../assets/img/tutorialimages/loginGuide1.png";
//? Japanese Version
import loginInstruction1Jap from "../../../assets/img/tutorialimages/loginGuide1_Jap.png";

class RegisterLoginGuidebot extends Component {
  state = {
    language: "en",
  };

  componentDidMount() {
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            language: snapshot.val(),
          });
        });
    }
  }

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    const { language } = this.state;
    return (
      <div
        style={{
          width: "90%",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        <img
          className="imgStyle"
          src={
            language === "en"
              ? loginInstruction1
              : language === "ja"
              ? loginInstruction1Jap
              : language === "es"
              ? loginInstruction1
              : loginInstruction1
          }
          alt="loginInstruction1"
          style={{
            width: "100%",
            marginLeft: "auto",
            marginRight: "auto",
            height: "100%",
          }}
        />
      </div>
    );
  }
}

export default RegisterLoginGuidebot;
